import React from 'react';

import withAuthServerSideProps from '@/libs/auth';

import { PageLayout, PlatForm } from '@/layouts/shared';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTag from '@/components/ui/MetaTag';
const RefundPolicyPage = () => {
  return (
    <>
      <MetaTag title="Chính sách thu đổi" description="Chính sách thu đổi" />
      <div className="container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10">
        <div className="tw-flex tw-flex-col tw-px-0 lg:tw-px-10 tw-text-base tw-leading-7">
          <h1 className="tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase">
            Chính sách thu đổi
          </h1>
          <div className="tw-flex tw-flex-col tw-gap-y-2">
            <h2 className="tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold">1. Trang sức đính kim cương:</h2>
            <div className="tw-flex tw-items-center tw-justify-center tw-mt-3">
              <table className="tw-border tw-text-base">
                <thead>
                  <tr className="tw-text-primary-main tw-border-b tw-bg-secondary-70/[0.06]">
                    <th className="tw-px-[10px] tw-py-2 tw-w-58 tw-border-r">Trang sức kim cương</th>
                    <th className="tw-px-[10px] tw-py-2 tw-w-58 tw-border-r">
                      Đổi cao hơn hoặc ngang <br /> bằng
                    </th>
                    <th className="tw-px-[10px] tw-py-2 tw-w-58 tw-border-r">Đổi thấp hơn hoặc thu lại</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Dưới 100 triệu</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">-15%</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">-25%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Từ 100 triệu - dưới 200 triệu</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">-15%</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">-20%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Từ 200 triệu - dưới 500 triệu</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">-13%</td>
                    <td className="tw-py-1 tw-border-r">-18%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Từ 500 triệu - dưới 1 tỉ đồng</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">-10%</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">-15%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Từ 1 tỷ đồng trở lên</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">-8%</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">-13%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h3 className="tw-font-bold tw-text-lg tw-mt-3">* Điều kiện thu đổi:</h3>
            <ul>
              <li>- Giấy bảo đảm và giấy kiểm định (nếu có) phải nguyên vẹn (không gấp khúc, nhăn, bẩn,…).</li>
              <li>- Sản phẩm trang sức phải còn nguyên vẹn.</li>
              <li>- Viên kim cương phải còn nguyên vẹn (không trầy xướt, nứt, mẻ,…).</li>
              <li>
                - Sản phẩm khi giao dịch thu đổi phải đúng chính chủ, An Thư không liên quan đến các tranh chấp xảy ra
                khi giao dịch không đúng chính chủ sở hữu.
              </li>
              <li>- Quý khách cần cung cấp CCCD (hoặc bằng lái xe) khi thu đổi hoặc cà thẻ.</li>
            </ul>
            <h3 className="tw-font-bold tw-text-lg tw-mt-3">* Không đủ điều kiện thu đổi:</h3>
            <ul>
              <li>
                - Kim cương không nguyên vẹn: An Thư sẽ mua lại theo thỏa thuận dựa vào kết quả sau khi cắt mài lại viên
                kim cương (nếu được) hoặc có quyền từ chối thu mua.
              </li>
              <li>
                - Giấy kiểm định viên bị mất hoặc giấy kiểm định viên không nguyên vẹn: An Thư sẽ mua lại theo thỏa
                thuận và trừ phí làm lại Giấy kiểm định viên tại thời điểm đó.
              </li>
              <li>
                - Sản phẩm trang sức không còn nguyên vẹn: An Thư sẽ mua lại theo thỏa thuận hoặc có quyền từ chối thu
                mua khi hư hỏng, biến dạng nặng.
              </li>
            </ul>
          </div>
          <div className="tw-flex tw-flex-col tw-gap-y-2 tw-mt-2">
            <h2 className="tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold">
              2. Dòng trang sức kim cương kết hợp với:
            </h2>
            <div className="tw-flex tw-items-center tw-justify-center tw-mt-3">
              <table className="tw-border tw-text-base">
                <thead>
                  <tr className="tw-text-primary-main tw-border-b tw-bg-secondary-70/[0.06]">
                    <th className="tw-px-5 tw-py-2 tw-w-[348px] tw-border-r">
                      Dòng trang sức kim cương kết hợp với:
                      <br /> (thu lại và đổi là như nhau)
                    </th>
                    <th className="tw-px-5 tw-py-2 tw-w-[348px] tw-border-r"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-px-6">Đá màu</td>
                    <td className="tw-py-1 tw-border-r tw-px-6">-30%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-px-6">Ngọc trai</td>
                    <td className="tw-py-1 tw-border-r tw-px-6">-40%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h3 className="tw-font-bold tw-text-lg tw-mt-3">* Điều kiện thu đổi:</h3>
            <ul>
              <li>
                - Giấy bảo đảm và giấy kiểm định kim cương, đá màu (nếu có) phải nguyên vẹn (không gấp khúc, nhăn,
                bẩn,…).
              </li>
              <li>- Sản phẩm trang sức phải còn nguyên vẹn.</li>
              <li>- Viên kim cương và đá màu phải còn nguyên vẹn (không trầy xướt, nứt, mẻ,…).</li>
              <li>
                - Sản phẩm khi giao dịch thu đổi phải đúng chính chủ, An Thư không liên quan đến các tranh chấp xảy ra
                khi giao dịch không đúng chính chủ sở hữu.
              </li>
              <li>- Quý khách cần cung cấp CCCD (hoặc bằng lái xe) khi thu đổi hoặc cà thẻ.</li>
            </ul>
            <h3 className="tw-font-bold tw-text-lg tw-mt-3">* Không đủ điều kiện thu đổi:</h3>
            <ul>
              <li>
                - Kim cương, đá màu không nguyên vẹn: An Thư sẽ mua lại theo thỏa thuận dựa vào kết quả sau khi cắt mài
                lại (nếu được) hoặc có quyền từ chối thu mua.
              </li>
              <li>
                - Giấy kiểm định viên bị mất hoặc giấy kiểm định viên không nguyên vẹn: An Thư sẽ mua lại theo thỏa
                thuận và trừ phí làm lại Giấy kiểm định viên tại thời điểm đó.
              </li>
              <li>
                - Sản phẩm trang sức không còn nguyên vẹn: An Thư sẽ mua lại theo thỏa thuận hoặc có quyền từ chối thu
                mua khi hư hỏng, biến dạng nặng.
              </li>
            </ul>
          </div>
          <div className="tw-flex tw-flex-col tw-gap-y-2 tw-mt-2">
            <h2 className="tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold">3. Đồng hồ đính kim cương:</h2>
            <div className="tw-flex tw-items-center tw-justify-center tw-mt-3">
              <div className="tw-flex">
                <span className="tw-border tw-block tw-w-[200px] md:tw-w-[348px] tw-p-[10px] tw-bg-secondary-70/[0.06] tw-text-primary-main tw-font-semibold ">
                  Đồng hồ đính kim cương (thu lại và đổi là như nhau)
                </span>
                <span className="tw-w-[200px] md:tw-w-[348px] tw-border-t tw-border-b tw-border-r tw-p-[10px] tw-flex tw-items-center tw-justify-center tw-text-center">
                  -40%
                </span>
              </div>
            </div>
            <h3 className="tw-font-bold tw-text-lg tw-mt-3">* Điều kiện thu đổi:</h3>
            <ul>
              <li>
                - Giấy bảo đảm và giấy kiểm định kim cương (nếu có) phải nguyên vẹn (không gấp khúc, nhăn, bẩn,…).
              </li>
              <li>- Sản phẩm đồng hồ phải còn nguyên vẹn (không rớt viên, không biến dạng,…).</li>
              <li>- Viên kim cương, đá màu phải còn nguyên vẹn (không trầy xướt, nứt, mẻ,…).</li>
              <li>
                - Sản phẩm khi giao dịch thu đổi phải đúng chính chủ, An Thư không liên quan đến các tranh chấp xảy ra
                khi giao dịch không đúng chính chủ sở hữu.
              </li>
              <li>- Quý khách cần cung cấp CCCD (hoặc bằng lái xe) khi thu đổi hoặc cà thẻ.</li>
            </ul>
            <h3 className="tw-font-bold tw-text-lg tw-mt-3">* Không đủ điều kiện thu đổi:</h3>
            <ul>
              <li>
                - Kim cương, đá màu không nguyên vẹn: An Thư sẽ mua lại theo thỏa thuận dựa vào kết quả sau khi cắt mài
                lại (nếu được) hoặc có quyền từ chối thu mua.
              </li>
              <li>
                - Giấy kiểm định viên kim cương, đá màu bị mất hoặc giấy kiểm định viên kim cương, đá màu không nguyên
                vẹn: An Thư sẽ mua lại theo thỏa thuận và trừ phí làm lại Giấy kiểm định viên tại thời điểm đó.
              </li>
              <li>
                - Sản phẩm đồng hồ không còn nguyên vẹn: An Thư sẽ mua lại theo thỏa thuận hoặc có quyền từ chối thu mua
                khi hư hỏng, biến dạng nặng.
              </li>
              <li>
                - Sản phẩm đồng hồ có dấu hiệu đã qua chỉnh sửa, cạy mở. Sản phẩm đồng hồ bị vô chất lỏng, khí hơi.
              </li>
            </ul>
            <p className="tw-italic">* Lưu ý:</p>
            <ul>
              <li>
                - Đồng hồ đính kim cương là dòng trang sức không có tính chịu nước, khí hơi, bụi bẩn,… bởi các khe cắm
                chấu kim cương.
              </li>
              <li>
                - Trong trường hợp đồng hồ bị vô chất lỏng, khí hơi, … hãy liên hệ ngay với An Thư để chúng tôi giúp bạn
                xử lý kịp thời.
              </li>
            </ul>
          </div>
          <div className="tw-flex tw-flex-col tw-gap-y-2 tw-mt-2">
            <h2 className="tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold">
              4. Một số sản phẩm không thu đổi:
            </h2>
            <div className="tw-flex tw-items-center tw-justify-center tw-mt-3">
              <div className="tw-flex">
                <span className="tw-border tw-block tw-w-[200px] md:tw-w-[348px] tw-p-[10px] tw-bg-secondary-70/[0.06] tw-text-primary-main tw-font-semibold ">
                  Không thu đổi
                </span>
                <span className="tw-w-[200px] md:tw-w-[348px] tw-border-t tw-border-b tw-border-r tw-p-[10px] tw-flex tw-items-center tw-justify-center tw-text-center">
                  Giá bán theo thỏa thuận
                </span>
              </div>
            </div>
            <p className="tw-italic">* Lưu ý:</p>
            <p>
              Quý khách mong muốn sở hữu vĩnh viễn, không có nhu cầu thu lại hay đổi qua sản phẩm khác bởi An Thư, có
              thể đề xuất quy chế không thu đổi để An Thư báo một mức giá tốt hơn so với giá niêm yết.Khi đã giao dịch
              với chế độ không thu đổi mà Quý khách mong muốn An Thư thu đổi thì An Thư có thể cân nhắc thu theo thỏa
              thuận hoặc có quyền từ chối thu mua.
            </p>
          </div>
          <div className="tw-flex tw-flex-col tw-gap-y-2 tw-mt-2">
            <h2 className="tw-text-lg tw-mt-3 tw-text-primary-main tw-font-semibold">5. Các sản phẩm khác:</h2>
            <div className="tw-flex tw-items-center tw-justify-center tw-mt-3">
              <div>
                <div className="tw-flex">
                  <span className="tw-border-t tw-border-r tw-border-l tw-border-b tw-block tw-w-[200px] md:tw-w-[348px] tw-p-[10px] tw-bg-secondary-70/[0.06] tw-text-primary-main tw-font-semibold ">
                    Hàng đặt chỉnh sửa theo yêu cầu/theo mẫu của Khách hàng/Sản phẩm có thiết kế cầu kì, phức tạp, thành phần kim cương hoặc đá màu đặc sắc
                  </span>
                  <span className="tw-w-[200px] md:tw-w-[348px] tw-border-t tw-border-r tw-border-b tw-p-[10px] tw-flex tw-items-center tw-justify-center tw-text-center">
                    Thu đổi theo thỏa thuận
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale, query }: GetServerSidePropsContext) => {
    const platform = query?.platform || PlatForm.Web;
    return {
      props: {
        layout: PageLayout.New,
        platform,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default RefundPolicyPage;
